import React from 'react';
// import Joyride from 'react-joyride';
// import theme from 'theme';
import { TourGuideProps } from './TourGuide.props';

// Temporary fallback component for React 19 compatibility
// TODO: Replace with a React 19 compatible tour library
const TourGuide = ({ run, stepIndex, steps, onCallback }: TourGuideProps) => 
  // For now, just return null to avoid breaking the build
  // In a real implementation, you would use a React 19 compatible tour library
  null
;

export default TourGuide;
